export function groupBy<T>(array: T[], keyGetter: (item: T) => string): T[][] {
	const result = array.reduce<Record<string, T[]>>((acc, item) => {
		const key = keyGetter(item);
		if (!acc[key]) {
			acc[key] = [];
		}
		acc[key].push(item);
		return acc;
	}, {});
	return Object.values(result);
}

export const makeObjEmptyArray = <T extends Record<string, unknown>>(keys: string[]): Record<keyof T, never[]> =>
	keys.reduce<Record<keyof T, never[]>>(
		(acc, key) => {
			acc[key as keyof T] = [];
			return acc;
		},
		// eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
		{} as Record<keyof T, never[]>,
	);
